<template>
  <div class="bg-gray p-2 mt-1">
    <div class="bg-white rounded p-3">
      <validation-observer ref="manageInformationRef">
        <div class="w-100">
          <em class="fas fa-info-circle rounded-circle text-orange p-1" />
          <span class="ml-2 color-gray-7 font-weight-bold font-16">
            {{ title }}
          </span>
        </div>
        <div class="row mx-0 mt-3 ml-n2">
          <div class="col-12 col-md-3 mb-3 mb-md-0">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-date-picker
                v-model="model.date"
                label="Fecha:"
                :max-date="new Date()"
                placeholder="DD/MM/YYYY"
                :error="errors[0]"
                custom-error-msg="La fecha es requerida."
              />
            </validation-provider>
          </div>
          <div v-if="hasReason" class="col-12 col-md-9 mb-3 mb-md-0">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="model.selectedReason"
                :options="reasons"
                label="Razón:"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                :error="errors[0]"
                custom-error-msg="La razón es requerida."
              />
            </validation-provider>
          </div>
          <div
            class="col-12 col-md-9 mb-3 mb-md-0"
            :class="{ 'col-md-12 mt-3': hasReason }"
          >
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-text-area
                v-model="model.comment"
                label="Comentario:"
                :maxlength="3000"
                show-char-count
                :count-classes="['d-block text-right']"
                :error="errors[0]"
                custom-error-msg="El comentario es requerido."
              />
            </validation-provider>
          </div>
        </div>
        <div class="row">
          <div class="col-12 d-flex justify-content-end mt-4 pr-4">
            <action-button
              variant="outline-danger mr-2"
              i="fas fa-times-circle"
              text="Cancelar"
              @click="$emit('on-close')"
            />
            <action-button
              variant="success"
              text="Guardar"
              i="fas fa-save"
              @click="onSaveHandler"
            />
          </div>
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import CustomDatePicker from "custom-date-picker";
import CustomDropDown from "custom-drop-down";
import CustomTextArea from "CustomTextArea";
import ActionButton from "ActionButton";
import alertMixin from "utils/mixins/alert.mixin";

export default {
  name: "ManageInformation",
  mixins: [alertMixin],
  components: {
    CustomDatePicker,
    CustomDropDown,
    CustomTextArea,
    ActionButton,
  },
  props: {
    title: {
      type: String,
      default: () => "",
    },
    reasons: {
      type: Array,
      default: () => [],
    },
    hasReason: {
      type: Boolean,
      default: () => false,
    },
    serviceViewTypeId: {
      type: Number,
      default: () => 0,
    },
    stipulationType: {
      type: Number,
      default: 0,
    }
  },
  data: () => ({
    model: {
      date: null,
      comment: null,
      selectedReason: null,
    },
  }),
  methods: {
    async onSaveHandler() {
      const isValid = await this.$refs.manageInformationRef.validate();
      if (!isValid) {
        this.ShowToast("Atención", "Información Incompleta.", "error");
        return;
      }
      this.$emit("on-save-manage-information", {
        ...this.model,
        stipulationType: this.stipulationType,
        serviceViewTypeId: this.serviceViewTypeId,
      });
    },
  },
};
</script>

<style></style>
